import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { useLanguage } from '../context/LanguageContext';

// Founder portrait - professional photo (Dubai lobby)
const FOUNDER_PORTRAIT = "https://customer-assets-lxgj4vgw.emergentagent.net/job_f0cb9bf6-3bfe-4bfd-b415-ea3503bce85a/artifacts/mmnt1y23_WhatsApp%20Image%202026-07-28%20at%2012.19.55.jpeg";

// English founder story paragraphs
const englishStory = [
  "I was born on the shores of the Black Sea, where life moves with the rhythm of the waves rather than the pressure of the clock. Surrounded by forests, mountains, rivers, and the endless horizon of the sea, I learned something long before I could put it into words:",
  "Human beings are not separate from nature—we belong to it.",
  "As life unfolded, my path took an unexpected direction.",
  "I studied Electrical and Electronics Engineering and built an international career that led me through technology, innovation, intellectual property, tourism, hospitality, real estate, and business development. My journey carried me from the peaceful coastline of the Black Sea to Germany, global organizations, demanding projects, airports, boardrooms, and the relentless pace of modern professional life.",
  "At first glance, these industries seem unrelated. Today, I see them differently.",
  "Each one taught me how to create value, solve problems, build trust, and design meaningful experiences for people.",
  "Along the way, I experienced the excitement of success, the weight of responsibility, the uncertainty of change, and the constant pursuit of the next milestone.",
  "Then I realized something that quietly changed my life.",
  "Modern life teaches us how to achieve. It rarely teaches us how to pause.",
  "Sometimes what we need most is not another accomplishment, but a moment of stillness. A deep breath. A silent morning. A walk through a forest. The sound of the ocean. A conversation without distractions.",
  "I don't believe nature changes who we are. I believe it reminds us who we have always been.",
  "That belief became the foundation of Omar Sharif Retreats.",
  "This is more than a travel company. It is the reflection of everything that has shaped my journey—engineering, technology, hospitality, international business, tourism, real estate, and a lifelong passion for creating experiences that genuinely enrich people's lives.",
  "Every retreat we design combines thoughtful planning with authentic human connection. Because a meaningful journey is never just about reaching a destination. It is about returning to yourself.",
  "We spend years building careers, growing businesses, chasing ambitions, and navigating life's inevitable highs and lows. Yet every so often, we owe ourselves something different.",
  "A chance to step away from the routine. To disconnect from constant expectations. To slow down. To breathe. To remember what truly matters.",
  "I believe every person should experience journeys that become personal turning points—journeys that allow them to return home not only with beautiful memories, but with renewed energy, a clearer perspective, and the courage to begin again.",
  "That is the experience we strive to create at Omar Sharif Retreats.",
  "Our purpose is not simply to show you extraordinary destinations. Our purpose is to help you rediscover yourself through them.",
  "Because sometimes, the most important place we can travel to is ourselves."
];

// Turkish founder story paragraphs
const turkishStory = [
  "Karadeniz kıyısında doğdum; hayatın saatin baskısıyla değil, dalgaların ritmiyle aktığı bir yerde. Ormanlar, dağlar, nehirler ve denizin sonsuz ufkuyla çevrili büyürken, daha sözlere dökemeden önce bir şey öğrendim:",
  "İnsan doğadan ayrı değildir—ona aittir.",
  "Hayat ilerledikçe, yolum beklenmedik bir yöne döndü.",
  "Elektrik ve Elektronik Mühendisliği okudum ve beni teknoloji, inovasyon, fikri mülkiyet, turizm, konaklama, gayrimenkul ve iş geliştirme alanlarından geçiren uluslararası bir kariyer inşa ettim. Yolculuğum beni Karadeniz'in huzurlu kıyılarından Almanya'ya, küresel organizasyonlara, zorlu projelere, havalimanlarına, toplantı odalarına ve modern profesyonel yaşamın durmak bilmeyen temposuna taşıdı.",
  "İlk bakışta bu sektörler birbirleriyle ilgisiz görünüyor. Bugün onlara farklı bakıyorum.",
  "Her biri bana değer yaratmayı, sorunları çözmeyi, güven inşa etmeyi ve insanlar için anlamlı deneyimler tasarlamayı öğretti.",
  "Bu süreçte başarının heyecanını, sorumluluğun ağırlığını, değişimin belirsizliğini ve bir sonraki hedefe ulaşma arayışını deneyimledim.",
  "Sonra hayatımı sessizce değiştiren bir şey fark ettim.",
  "Modern hayat bize nasıl başaracağımızı öğretiyor. Nadiren nasıl duracağımızı öğretiyor.",
  "Bazen en çok ihtiyacımız olan şey bir başka başarı değil, bir anlık durgunluktur. Derin bir nefes. Sessiz bir sabah. Ormanda bir yürüyüş. Okyanusun sesi. Dikkat dağıtıcılar olmadan bir sohbet.",
  "Doğanın kim olduğumuzu değiştirdiğine inanmıyorum. Her zaman kim olduğumuzu hatırlattığına inanıyorum.",
  "Bu inanç, Omar Sharif Retreats'in temeli oldu.",
  "Bu bir seyahat şirketinden fazlası. Yolculuğumu şekillendiren her şeyin yansıması—mühendislik, teknoloji, konaklama, uluslararası iş, turizm, gayrimenkul ve insanların hayatlarını gerçekten zenginleştiren deneyimler yaratma tutkusu.",
  "Tasarladığımız her inziva kampı, düşünceli planlamayı otantik insan bağlantısıyla birleştiriyor. Çünkü anlamlı bir yolculuk asla sadece bir varış noktasına ulaşmakla ilgili değildir. Kendine dönmekle ilgilidir.",
  "Yıllarımızı kariyer inşa ederek, iş büyüterek, hırsların peşinden koşarak ve hayatın kaçınılmaz iniş çıkışlarında yol alarak geçiriyoruz. Yine de ara sıra kendimize farklı bir şey borçluyuz.",
  "Rutinden uzaklaşma şansı. Sürekli beklentilerden kopma. Yavaşlama. Nefes alma. Gerçekten neyin önemli olduğunu hatırlama.",
  "Her insanın kişisel dönüm noktaları haline gelen yolculuklar deneyimlemesi gerektiğine inanıyorum—sadece güzel anılarla değil, yenilenmiş enerjiyle, daha net bir bakış açısıyla ve yeniden başlama cesaretiyle eve dönmelerini sağlayan yolculuklar.",
  "Omar Sharif Retreats'te yaratmaya çalıştığımız deneyim budur.",
  "Amacımız sadece size olağanüstü destinasyonlar göstermek değil. Amacımız onlar aracılığıyla kendinizi yeniden keşfetmenize yardımcı olmak.",
  "Çünkü bazen seyahat edebileceğimiz en önemli yer kendimizdir."
];

const AboutPage = () => {
  const { language } = useLanguage();
  const paragraphs = language === 'en' ? englishStory : turkishStory;
  const tagline = language === 'en' ? 'Meet the Founder' : 'Kurucumuzla Tanışın';

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.fade-element');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [language]);

  // Emphasis paragraphs (key statements)
  const emphasisIndexes = [1, 8, 10, 11];
  // Highlight paragraph (poetic list)
  const highlightIndex = 9;

  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <Navbar />
      
      <main className="pt-24 pb-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          
          {/* Two Column Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
            
            {/* LEFT COLUMN - Founder Portrait */}
            <div className="lg:col-span-5 lg:sticky lg:top-32">
              <div className="relative">
                <div className="relative overflow-hidden rounded-2xl">
                  <img
                    src={FOUNDER_PORTRAIT}
                    alt="Ömer Şerif Çavuşoğlu – Founder of Omar Sharif Retreats"
                    loading="lazy"
                    className="w-full h-auto object-cover aspect-[3/4] transition-transform duration-700 hover:scale-[1.02]"
                  />
                </div>
                
                <div className="mt-8 text-center lg:text-left">
                  <h2 className="font-serif text-2xl md:text-3xl text-gray-900 tracking-tight">
                    Ömer Şerif Çavuşoğlu
                  </h2>
                  <p className="mt-2 text-[#8B9D83] uppercase tracking-[0.25em] text-xs font-medium">
                    Founder
                  </p>
                  <p className="mt-1 text-gray-500 text-sm tracking-wide">
                    Omar Sharif Retreats
                  </p>
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN - Founder Story */}
            <div className="lg:col-span-7">
              <p className="text-[#8B9D83] uppercase tracking-[0.3em] text-xs font-medium mb-6">
                {tagline}
              </p>

              <article className="max-w-[720px]">
                {paragraphs.map((paragraph, index) => {
                  const isEmphasis = emphasisIndexes.includes(index);
                  const isHighlight = index === highlightIndex;
                  
                  let className = "fade-element opacity-0 translate-y-5 transition-all duration-700 ease-out ";
                  
                  if (isEmphasis) {
                    className += "font-serif text-xl md:text-2xl text-gray-800 italic my-10 leading-relaxed";
                  } else if (isHighlight) {
                    className += "text-gray-600 leading-relaxed text-base md:text-lg pl-6 border-l-2 border-[#8B9D83]/30 my-8";
                  } else {
                    className += "text-gray-600 leading-relaxed text-base md:text-lg mb-6";
                  }
                  
                  return (
                    <p
                      key={index}
                      className={className}
                      style={{ transitionDelay: `${Math.min(index * 50, 500)}ms` }}
                    >
                      {paragraph}
                    </p>
                  );
                })}
              </article>

              {/* Premium Quote Block */}
              <div className="mt-20 pt-16 border-t border-gray-200/60">
                <blockquote className="text-center max-w-2xl mx-auto">
                  <p className="font-serif text-2xl md:text-3xl lg:text-4xl text-gray-800 italic leading-snug tracking-tight">
                    "Not every journey changes your location.
                    <br />
                    <span className="text-[#8B9D83]">The best ones change your perspective."</span>
                  </p>
                  <footer className="mt-8">
                    <span className="text-gray-400 tracking-[0.2em] text-sm uppercase">
                      — Omar Sharif Retreats
                    </span>
                  </footer>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default AboutPage;
